import React,{ useState,useEffect } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types';
import i18nMessages from "../../../constants/messages/pt-BR"
import { getImageButton } from "../../../utils/uiHelper"
import styles from './popup-tw-styles'
import Button from '../../Generic/Button/Button'

const PopUp=({ popupdata,widthVar = 0 })=>{

    const { variant }=popupdata
    const [showPop,setShowPop]=useState(false)

    useEffect(()=>{

        if (typeof window!= 'undefined'){
            !window.sessionStorage.getItem('ShowPopUp') && setShowPop(true)
        }
    },[])
    
    const closePopup=()=>{
        setShowPop(false)
        window.sessionStorage.setItem('ShowPopUp',false)
    }

    const renderPopUp=(variant,popupdata)=>{

        switch (variant) {
        case 'Pro V Miracle':
            return (
              <div className={classnames(styles.popup)}>
                {showPop && widthVar<=760 &&  (
                <div>
                  <Button className={classnames(styles.closeButton)} handler={closePopup}>X</Button>
                    
                  <div className={classnames(styles.contentWrapper)}> 
                    {popupdata?.popUpContentCollection?.items.map(content=>{
                            switch(content.__typename){
                            case i18nMessages.ImageButton:
                                return getImageButton(content)
                            }
                        })}
                  </div>
                </div>
)}
              </div>
)
        
        default:
            break
        }
    }

    return (
      <div className={classnames(styles.popupWrapper)}>
        {variant && renderPopUp(variant,popupdata)}
      </div>

    )
}

PopUp.propTypes = {
    popupdata: PropTypes.objectOf(
        PropTypes.oneOfType([PropTypes.any, PropTypes.object])
    ).isRequired,
    widthVar:PropTypes.number
}
export default PopUp